import { LangSwitch } from '../comp/chooseLang/ChooseLang';
import type { PageContent } from '../comp/chooseLang/ChooseLang';
import ImageParagraph from '../comp/imgParagraph/ImageParagraph';
import './Global.css'

const repoUrl = 'https://github.com/1mB33/WarehouseManagmentApp';
const exampleClassUrl = 'https://github.com/1mB33/WarehouseManagmentApp/blob/main/src/main/java/PojazdyOsobowe/Warehouse/Products/OnionDummyTestClass.java';

const pageContentPl: PageContent[] = [
    {
        header: 'Na stronie (kliknij aby przejść):',
        type: 'pageNav',
        content: '#o-projekcie, #opis, #wyjatkowosc',
        custom: null
    },

    // ---------- O projekcie ----------
    {
        header: '#o-projekcie',
        type: 'full',
        content: 'Projekt został stworzony na zaliczenie przedmiotu programowania w języku Java. Wykonany w Javie z użyciem Java Swing, a pliki projektu zostały wygenerowane przy użyciu Mavena.',
        custom: null
    },
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <ImageParagraph
            Header='Aplikacja zarządzająca magazynem'
            Paragrahps={<>
                <a href={repoUrl} target='_blank' rel='noopener noreferrer'>Kod źródłowy na GitHubie</a>
                <br />
                <a href={exampleClassUrl} target='_blank' rel='noopener noreferrer'>Przykład minimalnej implementacji klasy obsługiwanej przez aplikację</a>
            </>}
            Img='/jv-promo.png'
            Type=''
            MaxHeight={360} />
    },
    {
        header: 'alt',
        type: 'spacer',
        content: '',
        custom: null
    },

    // ---------- Opis ----------
    {
        header: '#opis',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: 'Tłumaczenia',
        type: 'sub',
        content: 'Interfejs można w łatwy sposób przetłumaczyć na różne języki, dodając plik z tłumaczeniem w formacie JSON.',
        custom: null
    },
    {
        header: 'Filtrowanie i sortowanie',
        type: 'sub',
        content: 'Dynamiczne filtrowanie i sortowanie tabel jest dostępne po kliknięciu prawym przyciskiem myszy na daną kolumnę.',
        custom: null
    },
    {
        header: 'Wydajność',
        type: 'sub',
        content: 'Aplikacja była testowana na bazie danych złożonej z 10 000 wpisów i działała na akceptowalnym poziomie. Większe bazy danych mogą spowalniać aplikację, ponieważ wykorzystuje ona tylko jeden wątek.',
        custom: null
    },
    {
        header: 'Kod',
        type: 'sub',
        content: 'Kod powinien być stosunkowo prosty do rozbudowania. Komentarze są w języku polskim, ponieważ projekt powstał na zaliczenie przedmiotu.',
        custom: null
    },
    {
        header: '',
        type: 'spacer',
        content: '',
        custom: null
    },

    // ---------- Wyjątkowość ----------
    {
        header: '#wyjatkowosc',
        type: 'full',
        content: 'Czym wyróżnia się ten projekt?',
        custom: null
    },
    {
        header: 'Klasy produktów oparte na refleksji',
        type: 'sub',
        content: 'Aplikacja potrafi wyświetlać, zapisywać do pliku CSV i wczytywać z niego klasy dziedziczące po klasie produktu. Takie klasy są łatwe do zaimplementowania.',
        custom: null
    },
    {
        header: 'Dynamiczny interfejs',
        type: 'sub',
        content: 'Interfejs jest renderowany dynamicznie na podstawie klasy dziedziczącej po produkcie, którą zaimplementował programista.',
        custom: null
    },
];

const pageContentEn: PageContent[] = [
    {
        header: 'On this site (click to scroll):',
        type: 'pageNav',
        content: '#about, #description, #unique',
        custom: null
    },

    // ---------- About ----------
    {
        header: '#about',
        type: 'full',
        content: 'This project was made for a Java class assignment. It is written in Java with Swing, and the project files were generated with Maven.',
        custom: null
    },
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <ImageParagraph
            Header='Warehouse Management Application'
            Paragrahps={<>
                <a href={repoUrl} target='_blank' rel='noopener noreferrer'>Source code on GitHub</a>
                <br />
                <a href={exampleClassUrl} target='_blank' rel='noopener noreferrer'>Example of a minimal implementation of a product class</a>
            </>}
            Img='/jv-promo.png'
            Type=''
            MaxHeight={360} />
    },
    {
        header: 'alt',
        type: 'spacer',
        content: '',
        custom: null
    },

    // ---------- Description ----------
    {
        header: '#description',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: 'Translations',
        type: 'sub',
        content: 'The GUI can be easily translated into different languages by providing a JSON translation file.',
        custom: null
    },
    {
        header: 'Filtering and sorting',
        type: 'sub',
        content: 'Dynamic filtering and sorting of the tables is available after right-clicking a table column.',
        custom: null
    },
    {
        header: 'Performance',
        type: 'sub',
        content: 'The application was tested on a database with 10 000 entries and worked acceptably well. On larger databases a performance bottleneck might appear, because the application is single threaded.',
        custom: null
    },
    {
        header: 'Code',
        type: 'sub',
        content: 'The code should be relatively easy to build on. Comments are in Polish, because the project was done for a class assignment.',
        custom: null
    },
    {
        header: '',
        type: 'spacer',
        content: '',
        custom: null
    },

    // ---------- Unique ----------
    {
        header: '#unique',
        type: 'full',
        content: 'What makes it unique?',
        custom: null
    },
    {
        header: 'Reflection-based product classes',
        type: 'sub',
        content: 'The application uses reflection to handle product classes that are easy to implement, and saves them to or reads them from a CSV file.',
        custom: null
    },
    {
        header: 'Dynamic GUI',
        type: 'sub',
        content: 'The GUI is rendered dynamically, based on the class that the programmer derives from the product class.',
        custom: null
    },
];

function Warehouse() {
    var m = new Map<string, PageContent[]>();
    m.set('en', pageContentEn);
    m.set('pl', pageContentPl);

    return (
        <>
            <LangSwitch LangMap={m} />
        </>
    );
};

export default Warehouse;
